// Help & Contact Form JavaScript
document.addEventListener('DOMContentLoaded', function() {
  const helpSection = document.querySelector('.help-contact-section');
  if (!helpSection) return;

  const radioButtons = helpSection.querySelectorAll('input[type="radio"][name="help-category"]');
  const categorySelect = helpSection.querySelector('#HelpCategory');
  const helpForm = helpSection.querySelector('.help-form');
  const uploadSection = helpSection.querySelector('.help-upload-section');
  const phoneField = helpSection.querySelector('.help-phone-field');
  const emailField = helpSection.querySelector('.help-email-field');
  const messageField = helpSection.querySelector('.help-message-field');
  const namePhoneRow = helpSection.querySelector('.help-name-phone-row');
  const submitButton = helpSection.querySelector('.help-submit');

  // Toggle file upload section and hide/show fields based on category
  function toggleUploadSection(category) {
    const isGroupOrder = category === 'Submit Group Order';
    
    // Toggle upload section
    if (uploadSection) {
      uploadSection.style.display = isGroupOrder ? 'block' : 'none';
      
      const fileInput = uploadSection.querySelector('#HelpFileUpload');
      if (fileInput) {
        fileInput.required = isGroupOrder;
      }
    }

    // Change submit button text
    if (submitButton) {
      const defaultText = submitButton.dataset.defaultText || 'Contact Us';
      const groupOrderText = submitButton.dataset.groupOrderText || 'Send Your Request';
      submitButton.textContent = isGroupOrder ? groupOrderText : defaultText;
    }

    if (isGroupOrder) {
      // For Submit Group Order: Name + Email in one row, hide Phone and Message
      if (phoneField) {
        phoneField.style.display = 'none';
        const phoneInput = phoneField.querySelector('input');
        if (phoneInput) {
          phoneInput.required = false;
        }
      }
      
      // Move Email to the row (visually by changing parent to flex row)
      if (namePhoneRow && emailField) {
        // Email becomes part of the row
        namePhoneRow.style.gridTemplateColumns = '1fr 1fr';
        namePhoneRow.appendChild(emailField);
      }
      
      if (messageField) {
        messageField.style.display = 'none';
        const messageTextarea = messageField.querySelector('textarea');
        if (messageTextarea) {
          messageTextarea.required = false;
        }
      }
    } else {
      // Default: Name + Phone in one row, Email full width, Message full width
      if (phoneField) {
        phoneField.style.display = 'block';
      }
      
      // Move Email back to its original position (after the row)
      if (namePhoneRow && emailField) {
        const emailParent = emailField.parentElement;
        if (emailParent === namePhoneRow) {
          // Move email after the row
          namePhoneRow.parentElement.insertBefore(emailField, namePhoneRow.nextSibling);
        }
      }
      
      if (messageField) {
        messageField.style.display = 'block';
        const messageTextarea = messageField.querySelector('textarea');
        if (messageTextarea) {
          messageTextarea.required = true;
        }
      }
    }
  }

  // Sync radio buttons with dropdown
  if (radioButtons.length && categorySelect) {
    // Initialize upload section visibility
    toggleUploadSection(categorySelect.value);

    radioButtons.forEach(radio => {
      radio.addEventListener('change', function() {
        if (this.checked) {
          // Update dropdown to match selected radio
          categorySelect.value = this.value;
          
          // Toggle upload section
          toggleUploadSection(this.value);
          
          // Track analytics
          trackCategoryChange(this.value);
        }
      });
    });

    // Update radio when dropdown changes
    categorySelect.addEventListener('change', function() {
      const selectedValue = this.value;
      radioButtons.forEach(radio => {
        if (radio.value === selectedValue) {
          radio.checked = true;
        }
      });
      
      // Toggle upload section
      toggleUploadSection(selectedValue);
    });
  }

  // Form validation
  if (helpForm) {
    helpForm.addEventListener('submit', function(e) {
      const isValid = validateHelpForm(helpForm);
      
      if (!isValid) {
        e.preventDefault();
        return false;
      }

      // Track form submission
      trackFormSubmission(categorySelect ? categorySelect.value : 'Unknown');
    });

    // Real-time validation
    const inputs = helpForm.querySelectorAll('input[required], textarea[required]');
    inputs.forEach(input => {
      input.addEventListener('blur', function() {
        validateHelpField(this);
      });

      input.addEventListener('input', function() {
        if (this.classList.contains('error')) {
          validateHelpField(this);
        }
      });
    });
  }

  // Phone number formatting
  const phoneInput = helpSection.querySelector('#HelpPhone');
  if (phoneInput) {
    phoneInput.addEventListener('input', function(e) {
      formatPhoneNumber(e.target);
    });
  }

  // Auto-resize textarea
  const textarea = helpSection.querySelector('textarea');
  if (textarea) {
    textarea.addEventListener('input', function() {
      autoResizeTextarea(this);
    });
  }

  // File upload handling
  const fileInput = helpSection.querySelector('#HelpFileUpload');
  const uploadLabel = helpSection.querySelector('.help-upload-label');
  const fileInfo = helpSection.querySelector('.help-file-info');
  const fileName = helpSection.querySelector('.help-file-name');
  const fileRemove = helpSection.querySelector('.help-file-remove');
  const uploadNote = helpSection.querySelector('.help-upload-note');

  if (fileInput) {
    fileInput.addEventListener('change', function(e) {
      const file = e.target.files[0];
      
      if (file) {
        // Validate file size (5MB max)
        const maxSize = 5 * 1024 * 1024; // 5MB in bytes
        if (file.size > maxSize) {
          alert('File size must be less than 5MB');
          fileInput.value = '';
          return;
        }

        // Validate file type
        const allowedTypes = ['.pdf', '.doc', '.docx', '.xls', '.xlsx'];
        const fileExtension = '.' + file.name.split('.').pop().toLowerCase();
        if (!allowedTypes.includes(fileExtension)) {
          alert('Please upload a valid file type: PDF, DOC, DOCX, XLS, or XLSX');
          fileInput.value = '';
          return;
        }

        // Show file info and hide upload note
        if (fileName && fileInfo && uploadLabel) {
          fileName.textContent = file.name + ' (' + formatFileSize(file.size) + ')';
          uploadLabel.style.display = 'none';
          fileInfo.style.display = 'flex';
          
          // Hide the upload note text
          if (uploadNote) {
            uploadNote.style.display = 'none';
          }
        }
      }
    });

    // Remove file handler
    if (fileRemove) {
      fileRemove.addEventListener('click', function() {
        fileInput.value = '';
        if (uploadLabel && fileInfo) {
          uploadLabel.style.display = 'flex';
          fileInfo.style.display = 'none';
          
          // Show the upload note text again
          if (uploadNote) {
            uploadNote.style.display = 'block';
          }
        }
      });
    }
  }
});

// Validation Functions
function validateHelpForm(form) {
  let isValid = true;
  const requiredFields = form.querySelectorAll('[required]');

  requiredFields.forEach(field => {
    if (!validateHelpField(field)) {
      isValid = false;
    }
  });

  return isValid;
}

function validateHelpField(field) {
  const value = field.value.trim();
  const type = field.type;

  // Remove previous error
  field.classList.remove('error');
  removeHelpErrorMessage(field);

  // Check if empty
  if (!value && field.hasAttribute('required')) {
    showHelpError(field, 'This field is required');
    return false;
  }

  // Email validation
  if (type === 'email' && value) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(value)) {
      showHelpError(field, 'Please enter a valid email address');
      return false;
    }
  }

  // Phone validation
  if (type === 'tel' && value) {
    const phoneRegex = /^[\d\s\-\(\)\+]+$/;
    if (!phoneRegex.test(value) || value.replace(/\D/g, '').length < 10) {
      showHelpError(field, 'Please enter a valid phone number');
      return false;
    }
  }

  return true;
}

function showHelpError(field, message) {
  field.classList.add('error');
  
  const errorDiv = document.createElement('div');
  errorDiv.className = 'help-field-error';
  errorDiv.textContent = message;
  errorDiv.style.cssText = 'color: #d32f2f; font-size: 13px; margin-top: 4px; font-family: var(--font-family);';
  
  field.parentElement.appendChild(errorDiv);
}

function removeHelpErrorMessage(field) {
  const errorDiv = field.parentElement.querySelector('.help-field-error');
  if (errorDiv) {
    errorDiv.remove();
  }
}

// Phone Number Formatting
function formatPhoneNumber(input) {
  let value = input.value.replace(/\D/g, '');
  
  if (value.length >= 10) {
    // Format as (XXX) XXX-XXXX
    value = '(' + value.substring(0, 3) + ') ' + 
            value.substring(3, 6) + '-' + 
            value.substring(6, 10);
  }
  
  input.value = value;
}

// Auto-resize Textarea
function autoResizeTextarea(textarea) {
  textarea.style.height = 'auto';
  textarea.style.height = textarea.scrollHeight + 'px';
}

// Format File Size
function formatFileSize(bytes) {
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return Math.round((bytes / Math.pow(k, i)) * 100) / 100 + ' ' + sizes[i];
}

// Analytics Tracking
function trackCategoryChange(category) {
  if (typeof window.dataLayer !== 'undefined') {
    window.dataLayer.push({
      event: 'help_category_change',
      help_category: category
    });
  }
}

function trackFormSubmission(category) {
  if (typeof window.dataLayer !== 'undefined') {
    window.dataLayer.push({
      event: 'help_form_submit',
      help_category: category
    });
  }
}

// Add error styling via CSS
const helpStyle = document.createElement('style');
helpStyle.textContent = `
  .help-form-input.error,
  .help-form-textarea.error,
  .help-form-select.error {
    border-color: #d32f2f !important;
  }

  .help-form-input.error:focus,
  .help-form-textarea.error:focus,
  .help-form-select.error:focus {
    border-color: #d32f2f !important;
    box-shadow: 0 0 0 2px rgba(211, 47, 47, 0.1);
  }

  /* Success animation */
  .help-form-success {
    animation: helpSlideIn 0.3s ease;
  }

  @keyframes helpSlideIn {
    from {
      opacity: 0;
      transform: translateY(-10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  /* Loading state for submit button */
  .help-submit.loading {
    position: relative;
    color: transparent;
    pointer-events: none;
  }

  .help-submit.loading::after {
    content: '';
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 20px;
    height: 20px;
    border: 2px solid rgba(255, 255, 255, 0.3);
    border-top-color: #fff;
    border-radius: 50%;
    animation: helpSpin 0.6s linear infinite;
  }

  @keyframes helpSpin {
    to { transform: translate(-50%, -50%) rotate(360deg); }
  }
`;
document.head.appendChild(helpStyle);

// Add loading state to submit button
document.addEventListener('submit', function(e) {
  if (e.target.classList.contains('help-form')) {
    const submitBtn = e.target.querySelector('.help-submit');
    if (submitBtn && !submitBtn.classList.contains('loading')) {
      submitBtn.classList.add('loading');
      
      // Remove loading state after 3 seconds
      setTimeout(() => {
        submitBtn.classList.remove('loading');
      }, 3000);
    }
  }
}, true);

